module.exports = __webpack_public_path__ + "static/media/IMG_0087.882c5eec.jpg";